// extracted by mini-css-extract-plugin
export default {"mainWrapper":"main-wrapper__Q60IMgOi","main":"main__tQHyNaV5"};